import { render, staticRenderFns } from "./AccountOrders.vue?vue&type=template&id=2e674b4e&"
import script from "./AccountOrders.vue?vue&type=script&lang=js&"
export * from "./AccountOrders.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports